import styled, { css } from 'styled-components';

import {
    spaceMixin,
    mediaMixin,
} from '@zillow/constellation';

import { Col } from '@zillow/zrs-comet';

export const StyledEvenCol = styled(Col)(({
    even,
}) => css`
    ${even && css`
        padding-bottom: ${spaceMixin('xs')};
        ${mediaMixin('lg', css`
            padding-bottom: ${spaceMixin(0)};
        `)};
    `}
`);
